<div
  *ngIf="clusters.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="clusters"
    class="sp-width__full">
    <ng-container matColumnDef="cluster_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'CLUSTER.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let row">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ row.cluster_id }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="cluster_code">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'CLUSTER.CODE_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let row">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ row.cluster_code }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'CLUSTER.NAME_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let row">
        <span class="sp-color__primary sp-text__ellipsized"> {{ row.name }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'CLUSTER.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let row">
        <button
          (click)="onDetailClick(row)"
          mat-icon-button
          class="sp-icon__button sp-icon__button-accent"
          [matTooltip]="'CLUSTER.DETAIL_TOOLTIP' | translate">
          <mat-icon> visibility </mat-icon>
        </button>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
